import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=59d4e84e"
import script from "./OrderDetails.vue?vue&type=script&lang=js"
export * from "./OrderDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59d4e84e')) {
      api.createRecord('59d4e84e', component.options)
    } else {
      api.reload('59d4e84e', component.options)
    }
    module.hot.accept("./OrderDetails.vue?vue&type=template&id=59d4e84e", function () {
      api.rerender('59d4e84e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/OrderDetails.vue"
export default component.exports